import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import { AuthProvider, useAuth } from './context/AuthContext';
import { SubscriptionProvider } from './context/SubscriptionContext';
import { PaywallModal } from './components/Paywall';
import Landing from './pages/Landing';
import Login from './pages/Login';
import Register from './pages/Register';
import DashboardRouter from './pages/DashboardRouter';
import Quiz from './pages/Quiz';
import PaymentResult from './pages/PaymentResult';
import DemoLayout from './pages/demo/DemoLayout';
import Birthdays from './pages/Birthdays';
import SuperApp from './pages/SuperApp';
import './App.css';

const Private = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-navy font-heading text-2xl">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

// If a valid session exists, "/" jumps straight to /dashboard so users never re-enter credentials.
const LandingRoute = () => {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-navy font-heading text-2xl">Loading…</div>;
  if (user) return <Navigate to="/dashboard" replace />;
  return <Landing />;
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <SubscriptionProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<LandingRoute />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/dashboard" element={<Private><DashboardRouter /></Private>} />
              <Route path="/quiz" element={<Private><Quiz /></Private>} />
              <Route path="/payment/success" element={<PaymentResult status="success" />} />
              <Route path="/payment/cancel" element={<PaymentResult status="cancel" />} />
              <Route path="/demo" element={<DemoLayout />} />
              <Route path="/birthdays" element={<Private><Birthdays /></Private>} />
              <Route path="/super" element={<Private><SuperApp /></Private>} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
          <PaywallModal />
          <Toaster position="top-center" richColors />
        </SubscriptionProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
